import * as Sentry from "@sentry/react";
class BaseApiError extends Error {
}
function captureException(error, otherProps) {
  Sentry.captureException(error, { level: "error", ...otherProps });
}
function captureMessage(message, otherProps) {
  Sentry.captureMessage(message, { level: "info", ...otherProps });
}
const loggerUtils = {
  logMessageToConsole(message, ...optionalParameters) {
    console.log(message, ...optionalParameters);
  },
  logToConsole(error, extra) {
    console.error(error, extra);
  },
  logException(error, otherProps) {
    console.error(error, otherProps);
    if (!(error instanceof BaseApiError)) {
      captureException(error, {
        ...otherProps
      });
    }
  },
  logMessage(error, otherProps) {
    console.log(error, otherProps);
    captureMessage(error.message, {
      ...otherProps
    });
  }
};
export {
  BaseApiError as B,
  loggerUtils as l
};
//# sourceMappingURL=loggerUtils-CebMqdva.js.map
